import { out } from "../output/out";
import type { SessionDetail } from "@/lib/session/session-detail";
import { buildSessionDetailRows } from "@/lib/session/build-session-detail-rows";
import { printPlaybookSteps } from "@/lib/session/print-playbook-steps";

/** The single-session view shared by `get`, `run` and every control command. */
export function printSession(session: SessionDetail): void {
  // Titles, reasons, URLs and step names are agent-authored: sanitise before
  // they reach a terminal (see out.safe).
  out.line(
    `${out.paint(out.cell(session.title), "bold")}  ${out.status(session.status)}`,
  );

  const rows = buildSessionDetailRows(session);

  out.table(
    rows.map(([label, value]) => [out.paint(label ?? "", "dim"), value ?? ""]),
  );

  printPlaybookSteps(session.playbook?.steps ?? []);
}
